<!-- 主页面 -->
<template>
  <div class="home-com">
    <TxBg src="oldclassic_m_home_beijin">


      <div class="rank">
        <Select
          v-for="(nav, index) in nav_list"
          :src="nav.src"
          :op="nav.op"
          :key="index"
          :order_key="nav.order_key"
          @selectItem="selectItem"
        />
      </div>
      <Link />
      
    </TxBg>
  </div>
</template>
  
<script setup>
import { useRouter } from 'vue-router';
import Select from './components/home/Select.vue';
import Link from './components/link.vue';
const { is_mobile, schools, sectors, rank_type } = inject('GlobalStore');

const router = useRouter();

const school_op = computed(() => {
  const tmp = Object.entries(schools.value).map(([value, text]) => {
    return { text, value };
  });
  // tmp.unshift({ text: '所有门派', value: '' });
  return tmp;
});

const nav_list = computed(() => {
  return [
    {
      src: 'oldclassic_m_home_renwuxiuwei',
      op: school_op.value,
      order_key: 'xiuwei',
    },
    {
      src: 'oldclassic_m_home_zhuangping',
      op: school_op.value,
      order_key: 'equ_xiuwei',
    },
    {
      src: 'oldclassic_m_home_zongxiuwei',
      op: school_op.value,
      order_key: 'total_xiuwei',
    },
  ];
});

const selectItem = (school, order_key) => {
  console.log('selectItem', school, order_key);
  router.push({
    path: `/rank`,
    query: {
      school,
      order_key,
    },
  });
};
</script>

  